import { PaginatedResponse } from  "@/interfaces/api/PaginatedResponse";
import { ISourceListItem, ISourceListPaginatedResponse, modeType } from  "@/interfaces/CombinedFeed";
import { IHttpRequest } from  "@/interfaces/IHttp";
import { container, TYPES } from  "@/inversifyconfig/container.config";


const http = container.get<IHttpRequest>(TYPES.IHttpRequest); 

export async function getAllFeedModalItems(appId: string, listId: string, top: number, skip: number, feedId: string): Promise<PaginatedResponse<ISourceListItem>> {
    const url = `app/${appId}/list/${listId}/content?&top=${top}&skip=${skip}&feedId=${feedId}`;
    
    const res = await http.get(url);
    if(res.data) {
        return Promise.resolve(res.data)
    } 
     return Promise.reject(new Error(res.data || `Couldn't retrieve the content for modal`))
}

export async function getAllSourceLists(listId: string, top: number, skip: number, signal?: AbortSignal): Promise<ISourceListPaginatedResponse> {
    const url = `feed/${listId}/sources?top=${top}&skip=${skip}`;

    const res = await http.get(url, {signal});
    if(res.data) {
        return Promise.resolve(res.data)
    } 
     return Promise.reject(new Error(res.data || `Couldn't retrieve the source list`))
}

export async function setSourceListMode(feedId: string, payload:{mode: modeType}) {
    const res = await http.post(`feed/${feedId}/mode`, payload);
    
    if(res.status === 200) {
        return Promise.resolve(true)
    }
     return Promise.reject(new Error(res.data || `Couldn't set source list`))
}

export async function addSourceListToCombinedFeed(feedId: string, sourceListId: number) {
    const res = await http.put(`feed/${feedId}/sources/${sourceListId}`, {});

    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(res.data || `Couldn't add the source list`))
}

export async function removeSourceListFromCombinedFeed(feedId: string, sourceListId: number) {
    const res = await http.delete(`feed/${feedId}/sources/${sourceListId}`);

    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(res.data || "Couldn't remove the source list"))
}

export async function removeAllSourceListsFromCombinedFeed(feedId: string) {
    const res = await http.delete(`feed/${feedId}/sources`);

    if(res.status === 200) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(res.data || `Couldn't remove all source lists`))
}